import { useCurrentProfile } from '@map/state/profile';
import { windowExtended } from '@map/types';
import MuiThemeProvider from '@shared/components/MuiThemeProvider';
import { useCurrentLocale } from '@shared/hooks/intl';
import { getLocaleDirection } from '@shared/util/locale';
import { useMemo, type ReactNode } from 'react';
import { buildTheme } from '../../theme';

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const currentLocale = useCurrentLocale();
  const profile = useCurrentProfile();
  const localeDirection = getLocaleDirection(currentLocale);
  const theme = useMemo(
    () => buildTheme(localeDirection, profile.project_theme_colors || windowExtended.themeColors),
    [localeDirection, profile.project_theme_colors],
  );
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
